export default "__VITE_ASSET__CqqR4$gS__"